import { render, staticRenderFns } from "./IOSInstallation.vue?vue&type=template&id=4e7e5a4c&scoped=true"
import script from "./IOSInstallation.vue?vue&type=script&lang=ts"
export * from "./IOSInstallation.vue?vue&type=script&lang=ts"
import style0 from "./IOSInstallation.vue?vue&type=style&index=0&id=4e7e5a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e5a4c",
  null
  
)

export default component.exports